
import bgImg from './images/doc-back.jpg';
import XHeader from 'vux/src/components/x-header/index.vue'

import $ from 'jquery';
export default {
data () {
return {
bgImg,
listItem:{}
}
},
components: {
XHeader
},
methods: {
},
mounted(){
this.listItem = JSON.parse(this.$route.query.item)
}
}



// WEBPACK FOOTER //
// ./src/project/regionalServiceProject/regionalTeamDetail.vue